jQuery(document).foundation();

jQuery(document).on('closed.zf.reveal', '#how-it-goes', function() {
	var iframe = (jQuery)(this).find('iframe');
	if (iframe) {
		iframe.attr('src', '');
	}
});

jQuery('[data-open="how-it-goes"]').on('click', function() {
	var video = 'https://api.vadoo.tv/iframe_test?id=' + (jQuery)(this).data('video');
	jQuery('#how-it-goes').find('iframe').attr('src',video);
});

jQuery(document)
.on('keypress', function(event) {
    var keycode = (event.keyCode ? event.keyCode : event.which);
    
    if (keycode == '13' || keycode == '27') {
      jQuery('.select').removeClass('opened');
    }
})
.on('click', function() {
    jQuery('.select').removeClass('opened');
})
.on('click', '.select', function(event) {
    jQuery(this).toggleClass('opened');
	event.stopPropagation();
})
.on('click', '.select > .options > span', function(event) {
    var filter = jQuery(this).data('filter');
	var filterName = jQuery(this).text();
	jQuery(this).parent().parent().find('input').val(filter);
	jQuery(this).parent().parent().find('.option > span').text(filterName);
	jQuery(this).parent().find('span').removeClass('active');
	jQuery(this).addClass('active');
});

document.addEventListener("DOMContentLoaded", () => {
	if (window.matchMedia("(min-width: 64em)").matches) {
		var elementPadding = 130;
		
		jQuery('.section-overlap').each(function( index ) {
			var overlapHeight = jQuery(this).next().first().height()/2;
			jQuery(this).css( "padding-bottom", overlapHeight + elementPadding + "px");
			jQuery(this).next().first().css( "margin-bottom", -overlapHeight + "px");
		});
	}
	
	jQuery('.review').append('<div class="ico ico-quote1"><svg><use xlink:href="#svg-icon-quote"></svg></div><div class="ico ico-quote2"><svg><use xlink:href="#svg-icon-quote"></svg></div>');
});

